import { render, staticRenderFns } from "./Proposals.vue?vue&type=template&id=2279b64a&scoped=true&v-slot%3Aactivator=%7B%20on%20%7D&"
import script from "./Proposals.vue?vue&type=script&lang=js&"
export * from "./Proposals.vue?vue&type=script&lang=js&"
import style0 from "./Proposals.vue?vue&type=style&index=0&id=2279b64a&prod&scoped=true&lang=css&"
import style1 from "./Proposals.vue?vue&type=style&index=1&id=2279b64a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2279b64a",
  null
  
)

export default component.exports